(function () {
    'use strict';

    angular
        .module('invesfleet')
        .controller('DriverListController', DriverListController);


    DriverListController.$inject = [
        '$templateCache',
        'driverService',
        '$scope',
        '$rootScope',
        '$state',
        '$filter',
        '$q',
        'notificationService',
        '$timeout',
        'preferences',
        'simpleModalService',
        'genericDataService',
        'common',
        'uiGridConstants',
        'restrictionService'
    ];



    function DriverListController(
        $templateCache,
        driverService,
        $scope,
        $rootScope,
        $state,
        $filter,
        $q,
        notificationService,
        $timeout,
        preferences,
        simpleModalService,
        genericDataService,
        common,
        uiGridConstants,
        restrictionService
    ) {
        // jshint maxstatements:false

        /* PRIVATE VARIABLES */
        var templates = {
            accionesCellTemplate: $templateCache.get('app/views/tablesTemplates/generic/accionesCellTemplate.html'),
            rowTemplate: $templateCache.get('app/views/tablesTemplates/generic/rowTemplate.html'),
            stateTemplate: $templateCache.get('app/views/tablesTemplates/vehicles/stateTemplate.html'),
        };

        var sorting = {
            field: null,
            direction: null
        };

        var vm = this;
        vm.restrictionService = restrictionService; 
        vm.refreshData = refreshData; 

        vm.listaChoferesActivos = true;
        vm.focusedRow = null;
        vm.appliedFilters = [];
        vm.gridData = [];
        vm.rowCount = 0;
        vm.initialRowCount = 0;
        vm.firstLoaded = false;
        vm.alldriversResultList = [];
        vm.alldriversResultListWithFlters = [];
        vm.genericData = {
            estadoClientes: {
                list: [
                    { 'nombre': 'Activos', 'id': '0' },
                    { 'nombre': 'Choferes dados de baja', 'id': '1' },
                    { 'nombre': 'Todos', 'id': '2' }
                ],
                selected: { 'nombre': 'Activos', 'id': '0' }
            },
            empresas: {
                list: [],
                loading: true,
                selected: null
            }
        };
        vm.gridOptions = {
            rowTemplate: templates.rowTemplate,

            enableFilter: true,
            paginationPageSizes: [25, 50, 75],
            paginationPageSize: 25,
            useExternalPagination: true,

            enableRowSelection: true,
            multiSelect: true,

            enableColumnResizing: true,

            enableColumnMenus: false,
            treeRowHeaderAlwaysVisible: false,
            virtualizationThreshold: 200,
            primaryKey: 'operarioId',
            columnDefs: [
                {
                    field: 'estado',
                    displayName: 'Estado',
                    cellTemplate: templates.stateTemplate,
                    resizable: true,
                    width: 100
                },
                {
                    field: 'id',
                    displayName: 'Id',
                    resizable: true,
                    width: 80,
                    sort: { priority: 1, direction: 'desc' }
                },
                {
                    field: 'nombre',
                    cellClass: 'strong',
                    displayName: 'Nombre',
                    resizable: true,
                    minWidth: 100,
                    maxWidth: 120
                },
                {
                    name: 'apellidos',
                    displayName: 'Apellidos',
                    resizable: true,
                    minWidth: 100,
                    maxWidth: 220,
                },
                {
                    name: 'telefono',
                    displayName: 'Teléfono',
                    resizable: true,
                    minWidth: 100,
                    maxWidth: 220,
                },

                {
                    name: 'carne',
                    displayName: 'Carné',
                    resizable: true,
                    minWidth: 80,
                    maxWidth: 220,
                },
                {
                    field: 'empresaNombre',
                    displayName: 'Empresa',
                    minWidth: 150,
                    resizable: true

                },
                {
                    field: 'actions',
                    displayName: 'Acciones',
                    width: 90,
                    resizable: true,
                    cellClass: 'overflow',
                    cellTemplate: templates.accionesCellTemplate,
                    enableSorting: false
                }

            ],
            data: 'gridData',

            onRegisterApi: function (gridApi) {
                vm.gridApi = gridApi;
                vm.gridApi.grid.options.enableExpandAll = false;
            }
        };

        vm.dadosBaja = 'Mostrar dados de baja';
        vm.filterGrid = filterGrid;
        vm.goToEdit = goToEdit;
        vm.selectAll = selectAll;
        vm.clearAll = clearAll;
        vm.invertSelection = invertSelection;
        vm.selectOrClear = selectOrClear;
        vm.remove = remove;
        vm.refreshGrid = refreshGrid;
        vm.changeGrid = changeGrid;
        vm.deleteAllItems = deleteAllItems;
        vm.getEstadoName = getEstadoName;
        vm.getColorEstado = getColorEstado;
        vm.focusRow = focusRow;
        vm.isFocused = isFocused;
        vm.deleteSearchData = deleteSearchData;
        vm.estadoBajaChange = estadoBajaChange;
        vm.loaded = false; 

        vm.clearSearcher = clearSearcher;
        vm.searchText = '';
        vm.onSelectEmpresasClick = onSelectEmpresasClick;
        vm.selectEmpresasText = 'Todos';

        vm.tab = $rootScope.tabManager.tabs[$rootScope.tabManager.indexOfName('choferes')];

        (function () {
            var state = $rootScope.stateStorage[vm.tab.name];
            if (state && vm.tab.keepState) {
                vm.focusedRow = state.focusedRow || null;
            }
            loadData();
        })();

        $scope.$on('detail-resize', function (event, args) {
            if (vm.tab.isActive()) {
                $timeout(function () { if (!common.isNullOrUndefined(vm.gridApi)) vm.gridApi.core.handleWindowResize(); }, 0);
            }
        });

         function refreshData() {
             loadData();
         }
        function filterGrid() {
            if (vm.searchText !== '') {
                $scope.gridData = $filter('searchFilter')(vm.alldriversResultListWithFlters, {
                    'nombre': vm.searchText,
                    'apellidos': vm.searchText,
                    'id': vm.searchText,
                    'telefono': vm.searchText,
                    'carne': vm.searchText
                }, true);
            }
            else {
                $scope.gridData = vm.alldriversResultListWithFlters;
            }

            if (!common.isNullOrUndefined(vm.genericData.empresas.selected)) {
                $scope.gridData = $filter('searchFilter')($scope.gridData, {
                    'empresaNombre': vm.genericData.empresas.selected.nombre
                }, true);
            }
            vm.gridOptions.totalItems = $scope.gridData.length;
            vm.rowCount = $scope.gridData.length;
            vm.gridApi.core.notifyDataChange(uiGridConstants.dataChange.ALL);
        }

        $scope.$on('fleetdata-refreshed', function (event, args) {
            ////Save selected rows to mantain the selection after refreshing the data
            //var selected = vm.gridApi.selection.getSelectedRows();
            //filterGrid();
            //vm.clearAll();
            //var list = $scope.gridData;
            //for (var i = 0; i < list.length; i++) {
            //    var found = $filter('filter')(selected, { 'operarioId': list[i].operarioId });
            //    if (found[0]) {
            //        vm.gridApi.grid.modifyRows($scope.gridData);
            //        vm.gridApi.selection.selectRow($scope.gridData[i]);
            //    }
            //}
        });

        function loadData() {
            vm.loaded = false; 
            clearAll();

            getGenericData();

            driverService.getList(sorting, vm.appliedFilters).then(function (result) {
                result = addStateProperty(result);
                vm.gridOptions.totalItems = result.data.list.length;
                vm.alldriversResultList = result.data.list;
                vm.firstLoaded = true;
                vm.rowCount = result.data.list.length;
                vm.initialRowCount = result.data.list.length;

                $scope.gridData = result.data.list;
                vm.gridData = result.data.list;
                applyFilters();
                vm.loaded = true;
                filterGrid();
            });
        }


        function addStateProperty(result) {
            for (var i = 0; i < result.data.list.length; ++i) {
                var estado = getEstadoName(result.data.list[i].estado);
                result.data.list[i].nombreEstado = estado;
            }
            return result;
        }

        function focusRow(operario) {
            vm.focusedRow = operario.operarioId;
        }

        function isFocused(operario) {
            return vm.focusedRow === operario.operarioId;
        }

        function getEstadoName(estado) {
            if (estado === 0) {
                return 'Activo';
            } else if (estado === 1) {
                return 'Dado de baja';
            }
        }

        function selectAll() {
            vm.gridApi.selection.selectAllRows();
        }

        function clearAll() {
            if (!common.isNullOrUndefined(vm.gridApi))
                vm.gridApi.selection.clearSelectedRows();
        }

        function invertSelection() {
            var selected = vm.gridApi.selection.getSelectedRows();

            vm.selectAll();

            for (var i = 0; i < selected.length; i++) {
                vm.gridApi.selection.unSelectRow(selected[i]);
            }
        }

        function selectOrClear() {
            if (vm.gridApi.selection.getSelectAllState()) {
                vm.clearAll();
            } else {
                vm.selectAll();
            }
        }

        function goToEdit(operario) {
            vm.focusedRow = operario.operarioId;
            restrictionService.hasPermission(2, 'operario', 'flota.choferes.editar', { 'id': operario.operarioId });
            $state.go('flota.choferes.editar', { 'id': operario.operarioId });
        }

        function remove(operario) {
            if (!restrictionService.hasPermission(8, 'operario')) return; 

            notificationService.sendAppNotification({
                message: 'Dando de baja chófer...',
                positionY: 'top', positionX: 'right', delay: 3000, type: 'info'
            });
            driverService.deleteById([operario.operarioId]).then(function () {
                loadData();
                clearSearcher();
                notificationService.sendAppNotification({
                    message: 'Chófer dado de baja con éxito',
                    positionY: 'top', positionX: 'right', delay: 3000, type: 'success'
                });
            }, function () {
                notificationService.sendAppNotification({
                    message: 'Ha ocurrido un error al dar de baja el chófer',
                    positionY: 'top', positionX: 'right', delay: null, type: 'error'
                });
            });
        }

        function deleteAllItems() {
            if (!restrictionService.hasPermission(8, 'operario')) return; 

            simpleModalService
                .yesNoModal('Confirmación eliminar', '¿Desea eliminar los chóferes seleccionados?') // ' + vm.gridApi.selection.vm.gridApi.selection.getSelectedRows() + '
                .then(function (result) {
                    if (result) {
                        var driverIds = [];
                        var selected = vm.gridApi.selection.getSelectedRows();
                        for (var i = 0; i < selected.length; i++) {
                            driverIds.push(selected[i].operarioId);
                        }
                        notificationService.sendAppNotification({
                            message: 'Dando de baja chóferes...',
                            positionY: 'top', positionX: 'right', delay: 3000, type: 'info'
                        });
                        driverService.deleteById(driverIds)
                            .then(function () {
                                refreshGrid();
                                clearSearcher();
                                notificationService.sendAppNotification({
                                    message: 'Chóferes dados de baja con éxito',
                                    positionY: 'top', positionX: 'right', delay: 3000, type: 'success'
                                });
                            },
                                function () {
                                    notificationService.sendAppNotification({
                                        message: 'Ha ocurrido un error al dar de baja los chóferes',
                                        positionY: 'top', positionX: 'right', delay: null, type: 'error'
                                    });
                                });
                    }
                });
        }

        function refreshGrid() {
            loadData();
        }

        function getColorEstado(estado) {
            var estadoDriver = 'undefined';
            if (!common.isNullOrUndefined(preferences.prefs)) {
                estadoDriver = preferences.prefs.getStateColor(estado) || 'undefined';
            }

            return estadoDriver;
        }

        $scope.$on('$destroy', function () { //Save state
            $rootScope.stateStorage[vm.tab.name] = {
                focusedRow: vm.focusedRow
            };
        });

        function deleteSearchData() {
            vm.searchText = '';
            filterGrid();
        }

        function estadoBajaChange() {
            changeGrid();
        }

        function changeGrid() {
            applyFilters();
            filterGrid();
        }

        function applyFilters() {
            vm.alldriversResultListWithFlters = [];
            for (var i = 0; i < vm.alldriversResultList.length; ++i) {
                if ((vm.genericData.estadoClientes.selected.nombre === 'Todos')) {
                    vm.alldriversResultListWithFlters.push(vm.alldriversResultList[i]);
                }
                else if ((vm.genericData.estadoClientes.selected.nombre === 'Activos') &&
                    (0 === vm.alldriversResultList[i].estado)) {
                    vm.alldriversResultListWithFlters.push(vm.alldriversResultList[i]);
                }
                else if ((vm.genericData.estadoClientes.selected.nombre === 'Choferes dados de baja') &&
                    (1 === vm.alldriversResultList[i].estado)) {
                    vm.alldriversResultListWithFlters.push(vm.alldriversResultList[i]);
                }
            }

        }

        function getGenericData() {
            vm.genericData.empresas.loading = true;
            genericDataService.getEmpresas()
                .then(function (res) {
                    vm.genericData.empresas.loading = false;
                    vm.genericData.empresas.list = res;

                    if (vm.genericData.empresas.selected.id == null && defaultVal.empresa) {
                        vm.genericData.empresas.selected = vm.genericData.empresas.list[0];
                    }
                });
        }

        function clearSearcher() {
            vm.searchText = '';
            filterGrid();
        }

        function onSelectEmpresasClick(obj) {
            vm.genericData.empresas.selected = obj;

            if (obj !== null) {
                vm.selectEmpresasText = obj.nombre;
            } else {
                vm.selectEmpresasText = 'Todos';
            }

            filterGrid();
        }

    }

})();
